import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-notre-organisme-edit-mode',
  templateUrl: './notre-organisme-edit-mode.component.html',
  styleUrls: ['./notre-organisme-edit-mode.component.scss'],
})
export class NotreOrganismeEditModeComponent implements OnChanges {
  @Input() organisme!: Report.Organisme;
  @Input() reportId!: string;
  @Input() organismePhoto!: string | undefined;
  @Input() organismeLogo!: string | undefined;

  @Output() organismeChanged = new EventEmitter<Report.Organisme>();
  @Output() clearLogo = new EventEmitter();
  @Output() clearPhoto = new EventEmitter();
  @Output() changePhoto = new EventEmitter();
  @Output() changeLogo = new EventEmitter();

  organismeForm = new FormGroup({
    firstname: new FormControl(''),
    name: new FormControl(''),
    addressLine1: new FormControl(''),
    addressLine2: new FormControl(''),
    addressLine3: new FormControl(''),
    postalCode: new FormControl(''),
    city: new FormControl(''),
    expertise: new FormControl(''),
    titleService1: new FormControl(''),
    descriptionService1: new FormControl(''),
    titleService2: new FormControl(''),
    descriptionService2: new FormControl(''),
  });

  protected newOrganisme!: Report.Organisme;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['organisme']) {
      this.newOrganisme = structuredClone(this.organisme);

      this.setFormValues();
    }

    if (changes['organismePhoto'] && this.newOrganisme) {
      this.newOrganisme.photo = this.organismePhoto;
    }
    if (changes['organismeLogo'] && this.newOrganisme) {
      this.newOrganisme.logo = this.organismeLogo;
    }
  }

  onCroppedPhoto(croppedImage: string | undefined): void {
    this.changePhoto.emit(croppedImage);
  }

  onCroppedLogo(croppedImage: string | undefined): void {
    this.changeLogo.emit(croppedImage);
  }

  onClearPhoto() {
    this.clearPhoto.emit();
  }

  onClearLogo() {
    this.clearLogo.emit();
  }

  nameChanged(event: Event) {
    this.newOrganisme = {
      ...this.newOrganisme,
      name: (event.target as HTMLInputElement).value,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  addressLine1Changed(event: Event) {
    this.newOrganisme = {
      ...this.newOrganisme,
      addressLine1: (event.target as HTMLInputElement).value,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  addressLine2Changed(event: Event) {
    this.newOrganisme = {
      ...this.newOrganisme,
      addressLine2: (event.target as HTMLInputElement).value,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  addressLine3Changed(event: Event) {
    this.newOrganisme = {
      ...this.newOrganisme,
      addressLine3: (event.target as HTMLInputElement).value,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  postalCodeChanged(event: Event) {
    this.newOrganisme = {
      ...this.newOrganisme,
      postalCode: (event.target as HTMLInputElement).value,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  cityChanged(event: Event) {
    this.newOrganisme = {
      ...this.newOrganisme,
      city: (event.target as HTMLInputElement).value,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  expertiseChanged(event: Event) {
    this.newOrganisme = {
      ...this.newOrganisme,
      expertise: (event.target as HTMLInputElement).value,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  titleService1Changed(event: Event) {
    const updatedServices = [...this.newOrganisme.services];

    updatedServices[0] = {
      ...updatedServices[0],
      title: (event.target as HTMLInputElement).value,
    };

    this.newOrganisme = {
      ...this.newOrganisme,
      services: updatedServices,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  descriptionService1Changed(event: Event) {
    const updatedServices = [...this.newOrganisme.services];

    updatedServices[0] = {
      ...updatedServices[0],
      description: (event.target as HTMLInputElement).value,
    };

    this.newOrganisme = {
      ...this.newOrganisme,
      services: updatedServices,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  titleService2Changed(event: Event) {
    const updatedServices = [...this.newOrganisme.services];

    updatedServices[1] = {
      ...updatedServices[1],
      title: (event.target as HTMLInputElement).value,
    };

    this.newOrganisme = {
      ...this.newOrganisme,
      services: updatedServices,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  descriptionService2Changed(event: Event) {
    const updatedServices = [...this.newOrganisme.services];

    updatedServices[1] = {
      ...updatedServices[1],
      description: (event.target as HTMLInputElement).value,
    };

    this.newOrganisme = {
      ...this.newOrganisme,
      services: updatedServices,
    };

    this.organismeChanged.emit(this.newOrganisme);
  }

  private setFormValues(): void {
    this.organismeForm.controls.name.setValue(this.newOrganisme.name || '');
    this.organismeForm.controls.addressLine1.setValue(
      this.organisme.addressLine1 || '',
    );
    this.organismeForm.controls.addressLine2.setValue(
      this.organisme.addressLine2 || '',
    );
    this.organismeForm.controls.addressLine3.setValue(
      this.organisme.addressLine3 || '',
    );
    this.organismeForm.controls.postalCode.setValue(
      this.organisme.postalCode || '',
    );
    this.organismeForm.controls.city.setValue(this.newOrganisme.city || '');
    this.organismeForm.controls.expertise.setValue(
      this.organisme.expertise || '',
    );
    this.organismeForm.controls.titleService1.setValue(
      this.organisme.services[0]?.title || '',
    );
    this.organismeForm.controls.descriptionService1.setValue(
      this.organisme.services[0]?.description || '',
    );
    this.organismeForm.controls.titleService2.setValue(
      this.organisme.services[1]?.title || '',
    );
    this.organismeForm.controls.descriptionService2.setValue(
      this.organisme.services[1]?.description || '',
    );
  }
}
